<div class="flex flex-col gap-8 py-10">
  <div class="flex flex-row items-center gap-2">
    <svg-icon
      src="assets/icons/calculator.svg"
      svgClass="h-6 w-6 text-light-300"
    />

    <h3 class="font-extrabold text-2xl text-light-300">
      Investment calculator
    </h3>
  </div>

  <div class="flex flex-col gap-1">
    <p class="font-medium text-2xl text-light-100 text-center">
      Projected investment return of
    </p>
    <div class="flex flex-row gap-2 items-center justify-center">
      <p class="font-bold text-2xl text-light-200">
        {{ totalInvestment | customCurrency : currency : "1.0-0" }}
        <span class="text-light-100">in</span> 5 years
      </p>

      <svg-icon
        src="assets/icons/question-mark.svg"
        svgClass="w-6 h-6 text-light-100"
        (mouseenter)="popoverPI.show($event)"
        (mouseleave)="popoverPI.hide()"
      />

      <p-popover #popoverPI>
        <p class="w-72 text-light-0 text-base">
          Use this calculator to estimate the potential returns from your real
          estate investment. Simply adjust the sliders to see how the variables
          will impact your estimated returns.<br /><br />

          All projected values are before any property costs and platform fees,
          and based on a 5-year holding period. We expect the asset value to
          grow 30% over the next 5 years.
        </p>
      </p-popover>
    </div>
  </div>

  <div
    class="flex flex-col sm:flex-row gap-4 border border-light-180 rounded-lg py-3 px-6 justify-between items-start sm:items-center"
  >
    <div class="flex flex-col">
      <div class="flex flex-row gap-2 items-center">
        <div
          class="h-3 w-3 rounded-full"
          [style]="{
            'background-color':
              investmentChartConfig[InvestmentChartCatergory.INVESTMENT].color
          }"
        ></div>
        <span class="text-sm text-light-100">
          {{ investmentChartConfig[InvestmentChartCatergory.INVESTMENT].label }}
        </span>
      </div>

      <div class="flex flex-row gap-2 items-center">
        <div class="h-3 w-3"></div>
        <span class="font-bold text-sm text-light-300">
          {{ initialInvestment | customCurrency : currency : "1.0-0" }}
        </span>
      </div>
    </div>

    <div class="flex flex-col">
      <div class="flex flex-row gap-2 items-center">
        <div
          class="h-3 w-3 rounded-full"
          [style]="{
            'background-color':
              investmentChartConfig[InvestmentChartCatergory.VALUE_APPRECIATION]
                .color
          }"
        ></div>
        <span class="text-sm text-light-100">
          {{
            investmentChartConfig[InvestmentChartCatergory.VALUE_APPRECIATION]
              .label
          }}
        </span>
      </div>

      <div class="flex flex-row gap-2 items-center">
        <div class="h-3 w-3"></div>
        <span class="font-bold text-sm text-light-300">
          {{ valueAppreciation | customCurrency : currency : "1.0-0" }}
        </span>
      </div>
    </div>

    <div class="flex flex-col">
      <div class="flex flex-row gap-2 items-center">
        <div
          class="h-3 w-3 rounded-full"
          [style]="{
            'background-color':
              investmentChartConfig[InvestmentChartCatergory.RENTAL_INCOME]
                .color
          }"
        ></div>
        <span class="text-sm text-light-100">
          {{
            investmentChartConfig[InvestmentChartCatergory.RENTAL_INCOME].label
          }}
        </span>
      </div>

      <div class="flex flex-row gap-2 items-center">
        <div class="h-3 w-3"></div>
        <span class="font-bold text-sm text-light-300">
          {{ totalRentalIncome | customCurrency : currency : "1.0-0" }}
        </span>
      </div>
    </div>
  </div>

  <!-- CHART -->
  <div id="chart-area-container" class="chart-area-container mt-6">
    <div id="chart-area" style="height: 250px; width: 100%"></div>
  </div>

  <div class="flex flex-col gap-8">
    <div>
      <div class="flex flex-row gap-2 items-center mb-5 h-6.5">
        <span class="font-medium text-base text-light-100">
          Initial Investment
        </span>
        <div class="m-auto"></div>
        <span class="font-bold text-base text-light-300">
          {{ initialInvestment | customCurrency : currency : "1.0-0" }}
        </span>
      </div>

      <p-slider
        [(ngModel)]="initialInvestment"
        class="w-full"
        [min]="500"
        [max]="maxInvestment"
        [step]="500"
        (onChange)="onInvestmentValueChange(true)"
      />
    </div>

    <div>
      <div class="flex flex-row gap-2 items-center mb-5 h-6.5">
        <span class="font-medium text-base text-light-100">
          Property value growth (5 year)
        </span>
        <div class="m-auto"></div>
        <span class="font-bold text-base text-light-300">
          {{ propertyValueGrowth }}%
        </span>

        @if(propertyValueGrowth !== propertyValueGrowthInitialValue){
        <p-button
          styleClass="w-6 h-6"
          [rounded]="true"
          severity="secondary"
          [outlined]="true"
          (onClick)="onValueGrowthReset()"
        >
          <svg-icon src="assets/icons/reset.svg" svgClass="h-3 w-3" />
        </p-button>
        }
      </div>

      <p-slider
        [(ngModel)]="propertyValueGrowth"
        class="w-full"
        [min]="1"
        [max]="maxPropertyValueGrowth"
        [step]="1"
        (onChange)="onValueGrowthChange(true)"
      />
    </div>

    <div>
      <div class="flex flex-row gap-2 items-center mb-5 h-6.5">
        <span class="font-medium text-base text-light-100">
          Expected annual rental yield
        </span>
        <div class="m-auto"></div>
        <span class="font-bold text-base text-light-300">
          {{ expectedAnnualRentalYield }}%
        </span>

        @if(expectedAnnualRentalYield !==
        expectedAnnualRentalYieldInitialValue){
        <p-button
          styleClass="w-6 h-6"
          [rounded]="true"
          severity="secondary"
          [outlined]="true"
          (onClick)="onRentalGrowthReset()"
        >
          <svg-icon src="assets/icons/reset.svg" svgClass="h-3 w-3" />
        </p-button>
        }
      </div>

      <p-slider
        [(ngModel)]="expectedAnnualRentalYield"
        class="w-full"
        [min]="1"
        [max]="maxExpectedAnnualRentalYield"
        [step]="0.5"
        (onChange)="onRentalGrowthChange(true)"
      />
    </div>

    <div
      class="flex flex-row gap-2 items-center justify-center h-10 bg-light-50 rounded-lg py-2 px-4"
    >
      <p class="font-medium text-xs text-light-100 text-center">
        Default values are based on property numbers
      </p>

      <svg-icon
        src="assets/icons/question-mark.svg"
        svgClass="w-4 h-4 text-light-100"
        (mouseenter)="popoverDV.show($event)"
        (mouseleave)="popoverDV.hide()"
      />

      <p-popover #popoverDV>
        <p class="w-72 text-light-0 text-base">
          Default slider values for Projected property value growth and Expected
          annual rental yield are set to the actual property numbers. You can
          reset the sliders to see your returns based on the property net yield
          and value growth. Simply adjust the initial investment slider.
        </p>
      </p-popover>
    </div>
  </div>
</div>
